/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit City/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import Cities from './Cities/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function City({
  children,
  viewPath = "/DesignSystem/DataVaxiomOtherProfessionalsEdit/Content/Details/Office/City",
  isInvalid,
  onChange
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let editProfessionalOtherExternalOfficePostalAddressCityIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_professional',
path: 'other.external_office.postal_address.city',
validate: fromValidate.city,
required: true,
})
let citySearchTermValueData = fromData.useDataValue({ viewPath,
context: 'city_search',
path: 'term',
})
let citySearchTermChangeData = fromData.useDataChange({ viewPath,
context: 'city_search',
path: 'term',
})
  return (<React.Fragment
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 marginTop={dtSpaceM}
 text="City"
/>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaInput
{...childProps}
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 data="edit_professional.other.external_office.postal_address.city"
 validate="/Data/validate.js city"
 required={true}
 invalid={!editProfessionalOtherExternalOfficePostalAddressCityIsValidData}
 data="city_search.term"
 value={citySearchTermValueData}
 onChange={citySearchTermChangeData}
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Cities
{...childProps}
  viewPath={`${viewPath}/Cities`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}